import script from "./web-collection-type.vue?vue&type=script&setup=true&lang=js"
export * from "./web-collection-type.vue?vue&type=script&setup=true&lang=js"

import "./web-collection-type.vue?vue&type=style&index=0&id=2a6402ab&lang=scss"

const __exports__ = script;

export default __exports__